import React, { Component } from "react";
import { connect } from "react-redux";
import defaultImage from "../../../Images/dp.svg";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});
class HomeProfileCardV2 extends Component {
  render() {
    if (this.props.user.role.id === 9) {
      return (
        <div
          className="d-inline-flex pr-4 th-br-50 shadow-sm my-4"
          style={{
            background:
              "linear-gradient(180deg, rgba(255, 255, 255, 0.42) 0%, rgba(255, 255, 255, 0.16) 100%)",
            marginLeft: "5%",
          }}
        >
          <div>
            {this.props.user.studentData.student_photo ? (
              <Link to="/profilePic">
                <img
                  src={`${this.props.user?.studentData?.student_photo}`}
                  alt=""
                  className="th-br-50 p-2"
                  style={{ width: "60px" }}
                />
              </Link>
            ) : (
              <Link to="/profilePic">
                <img
                  src={defaultImage}
                  alt=""
                  className="th-br-50 p-2"
                  style={{ width: "60px" }}
                />
              </Link>
            )}
          </div>
          <div className="d-flex my-auto">
            <div className="mx-auto">
              <div className="th-16 th-white text-center th-medium th-fw-600">
                <span>Hello, </span> {this.props.user?.user?.first_name}
                {this.props.user?.user?.last_name}!
              </div>
              {/* <div className="th-12">
                {this.props.user.user.username} |{" "}
                {this.props.user.student_class.class_name} {" ( "}
                {this.props.user.student_section.section_name} {")"}
              </div> */}
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div
          className="d-inline-flex pr-4 th-bg-white th-br-50 shadow-sm my-4"
          style={{
            background:
              "linear-gradient(180deg, rgba(255, 255, 255, 0.42) 0%, rgba(255, 255, 255, 0.16) 100%)",
            marginLeft: "28%",
          }}
        >
          <div>
            {this.props.user?.staffData?.staff_image ? (
              <Link to="/profilePic">
                <img
                  src={`${this.props.user?.staffData?.staff_image}`}
                  alt=""
                  className="th-br-50 p-2"
                  style={{ width: "60px" }}
                />
              </Link>
            ) : (
              <Link to="/profilePic">
                <img
                  src={defaultImage}
                  alt=""
                  className="th-br-50 p-2"
                  style={{ width: "60px" }}
                />
              </Link>
            )}
          </div>
          <div className="d-flex my-auto">
            <div className="mx-auto">
              <div className="th-16 th-white text-center th-medium th-fw-600">
                <span>Hello, </span> {this.props.user?.user?.first_name}!
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}

export default connect(mapStateToProps)(HomeProfileCardV2);
